import { selectUser } from '@/redux/auth/authSlice';
import { useEffect } from 'react';
import { geCurrency } from '../../api/queries/getData';
import { setCurrency } from '../../redux/config/configSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { store } from '../../redux/store';

const useCurrencySetter = () => {
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const fetchCurrency = async () => {
    const storedCurrency = store.getState().config.currency;
    return geCurrency().then((res) => {
      if (res && storedCurrency != res) dispatch(setCurrency(res));
    });
  };
  useEffect(() => {
    if (user) fetchCurrency();
  }, [user]);

  return { refetch: fetchCurrency };
};

export { useCurrencySetter };
